/**
 * Converts a string to start case (capitalize first letter of each word, rest lowercase).
 * Also replaces underscores with spaces. Values often come back from the backend in
 * inconsistent casing (all lowercase, all caps, snake_case, etc.) -- normalize for display.
 */
export const toStartCase = (value: string): string => {
  if (!value) return value;
  return value
    .replace(/_/g, " ")
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
